import { AppInitializeService, SessionFacade } from '@frontend-site/shared/core';
import { combineLatest, firstValueFrom, Observable, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { getAuthenticationFromCookies, getCookies, VOID } from '@frontend-site/shared/utils';

export function appInit(doc: Document, session: SessionFacade, appInitializeService: AppInitializeService, httpClient: HttpClient) {
    return async (): Promise<unknown> => {
        preventMultiIframe();
        const isAuthenticated = getAuthenticationFromCookies(getCookies(doc), 'WAIT-FOR-LEGACY-BOOTSTRAPING');
        if (isAuthenticated === null) {
            session.clear();
            return firstValueFrom(VOID);
        }

        return await firstValueFrom(
            session.sessionInformation().pipe(switchMap(() => combineLatest([initTimeZoneOffset(httpClient), appInitializeService.init()])))
        );
    };
}

export function initTimeZoneOffset(httpClient: HttpClient): Observable<void> {
    const currentDate = new Date();
    return httpClient.post<void>('/rest/security/updateTimezoneOffset', currentDate.getTimezoneOffset());
}

const preventMultiIframe = () => {
    if (window !== top) {
        top.location.href = location.href;
    }
};
